import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { Label } from '@/components/ui/label'
import { Input } from '@/components/ui/input'
import { Checkbox } from "@/components/ui/checkbox"
import { Textarea } from '@/components/ui/textarea';
import { ycrAction } from '../../../../../store/actions/admin/ycrAction';
import { countryAction } from '../../../../../store/actions/countryAction';
import { ycrAssetAction } from '../../../../../store/actions/user/ycrAssetAction';
import {
    components,
} from 'react-select';
import ReactSelect from 'react-select'
import { currencyAction } from '../../../../../store/actions/currencyAction'
import { assetAddAction } from '../../../../../store/actions/admin/assetAction'
import countriesAccept from '../../../../../shared'
const AssetModel = (props) => {
    const dispatch = useDispatch()
    const { editedData } = props;
    const { countries, ycrData, ycrAssetData, assetValueData, currencyData } = useSelector(state => state);
    const [assetLabel, setAssetLabel] = useState(null)
    const [errors, setErrors] = useState({});
    const [groupedDataCurve, setGroupedDataCurve] = useState({});
    const [groupedDataTenure, setGroupedDataTenure] = useState({});
    const [formData, setFormData] = useState({
        countriesId: null,
        interestRateDataTypeId: null,
        assetIds: [],
        name: '',
        description: '',
        currencyId: null
    })

    useEffect(() => {
        if (props.show === false) {
            setFormData({
                countriesId: null,
                interestRateDataTypeId: null,
                assetIds: [],
                name: '',
                id: null,
                description: '',
                currencyId: null
            })
        }
    }, [props.show])

    useEffect(() => {
        props.show && dispatch(ycrAction({
            page: 1,
            perPage: 10
        }, null))
        dispatch(countryAction())
        dispatch(currencyAction())
    }, [props.show])

    useEffect(() => {
        if (editedData?.data?._id) {
            setFormData({
                id: editedData?.data?._id,
                countriesId: { label: editedData?.data?.country?.countryName, value: editedData?.data?.country?._id },
                interestRateDataTypeId: { label: editedData?.data?.interestRateDataType?.type, value: editedData?.data?.interestRateDataType?._id },
                assetIds: [editedData?.data?.interestRateDataTypeAsset?._id],
                name: editedData?.data?.name,
                description: editedData?.data?.description,
                currencyId: { label: editedData?.data?.currency?.currency, value: editedData?.data?.currency?._id, countryId: editedData?.data?.country?._id },
            })
            setAssetLabel(editedData?.data?.interestRateDataTypeAsset?.maturity)
        } else {
            setFormData({
                countriesId: null,
                interestRateDataTypeId: null,
                assetIds: [],
                name: '',
                description: '',
                currencyId: null
            })
        }
    }, [editedData])

    useEffect(() => {
        if (formData.countriesId !== null && formData.interestRateDataTypeId !== null && props.show) {
            const filter = {
                countryIds: [formData.countriesId.value],
                interestRateDataTypeIds: [formData.interestRateDataTypeId.value]
            }
            dispatch(ycrAssetAction(filter))
        }
    }, [formData.countriesId, formData.interestRateDataTypeId, props.show])

    const countryOptions = countries && countries.length ? countries.sort((a, b) => a.countryName.localeCompare(b.countryName)).filter((item) => countriesAccept.includes(item.countryName)).map((item) => {
        return { label: item.countryName, value: item._id }
    }) : []

    const InterestRateDataTypeOptions = ycrData?.records && ycrData?.records?.length ? ycrData?.records?.map((item) => {
        return { label: item.type, value: item._id }
    }) : []


    const assetOptions = ycrAssetData?.records && ycrAssetData?.records?.length ? ycrAssetData?.records?.map((items) => {
        return { label: items.maturity, value: items._id }
    }) : []

    const currencyOptions = currencyData && currencyData.records?.length ? currencyData?.records?.map((items) => {
        return { label: items.currency, value: items._id, countryId: items.country }
    }) : []

    const onChangeHandel = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        setErrors({})
    }

    const onChangeCountry = (e) => {
        setFormData({ ...formData, countriesId: e })
        setErrors({})
    }
    const onChangeCurrency = (e) => {
        setFormData({ ...formData, currencyId: e })
        setErrors({})
    }

    const onChangeInterestRateDataType = (e) => {
        setFormData({ ...formData, interestRateDataTypeId: e })
        setErrors({})
    }

    const onCheckedCustomFieldBox = (props) => {
        const { data } = props;
        setAssetLabel(data.label)

        if (data.value === 'all') {
            if (formData.assetIds?.length === assetOptions?.length) {
                setFormData({ ...formData, assetIds: [] });
            } else {
                setFormData({ ...formData, assetIds: assetOptions.map(option => option.value) });
            }
        } else {
            setFormData((prev) => {
                let newData;
                const alreadyExists = prev.assetIds.some(item => item === data.value);

                if (alreadyExists) {
                    const alreadyExistsData = prev.assetIds.filter(item => item !== data.value);
                    newData = alreadyExistsData
                } else {
                    newData = [data?.value];
                }
                return { ...prev, assetIds: newData?.filter((aed) => aed !== "all") }
            })
        }
        setErrors({})
    };

    const OptionCustomField = ({ children, ...props }) => {
        const { onCheckedCustomFieldBox } = props.selectProps;
        //props?.data?.value === "all" && !checkedData?.includes("all") && assetOptions?.length - 1 === checkedData?.length ? true :
        const checkedCondition = formData.assetIds?.includes(props.data.value)

        return (
            <components.Control {...props}>
                <div className="flex p-2 align-middle justify-start items-center text-sm w-full" onClick={() => onCheckedCustomFieldBox(props)}>
                    <span className="me-2">
                        <Checkbox
                            checked={checkedCondition}
                            aria-label="Select row"
                            // rounded-[4px]
                            className="translate-y-[2px] rounded-[4px] border-black " />
                    </span>
                    {children}
                </div>
            </components.Control>
        );
    };

    const handleValidation = () => {
        let valid = true;
        let error = {};
        if (formData.name === '') {
            error.names = "please enter name"
            valid = false
        }

        if (formData.currencyId === null) {
            error.currencyId = "please select any Currency"
            valid = false
        }

        if (formData.countriesId === null) {
            error.countriesId = "please select any Countries"
            valid = false
        }

        if (formData.interestRateDataTypeId === null) {
            error.interestRateDataTypeId = "please select any Curve"
            valid = false;
        }

        if (formData.assetIds === null || formData.assetIds?.length === 0) {
            error.assetIds = "please select Tenor"
            valid = false;
        }

        setErrors(error);
        return valid;
    };

    const preparedData = (isUpdate) => {
        let data = {
            name: formData.name,
            description: formData.description,
            country: formData.countriesId.value, 
            currency: formData.currencyId.value, 
            curve: formData.interestRateDataTypeId.value, 
            tenure: formData.assetIds[0] 
        }
        data = isUpdate ? { _id: formData.id, ...data } : { ...data }
        return data
    }

    const onSave = (e) => {
        if (handleValidation()) {
            e.preventDefault();
            if (editedData?.data?._id) {
                const data = preparedData(true)
                dispatch(assetAddAction(data))
            } else {
                const data = preparedData(false)
                dispatch(assetAddAction(data))
            }
            setFormData({
                countriesId: null,
                interestRateDataTypeId: null,
                assetIds: [],
                name: '',
                description: '',
                currencyId: null,
                id: null
            })
            props.onHide();
        }
    }




    // for curve group data

    useEffect(() => {
        const groupedData2 = ycrData?.records?.length > 0 && ycrData?.records.reduce((acc, curr) => {
            const countryName = curr.country.countryName;
            acc[countryName] = acc[countryName] || [];
            acc[countryName].push(curr);
            return acc;
        }, {});
        setGroupedDataCurve(groupedData2)
    }, [ycrData?.records]);

    const transformedDataCurve = Object.entries(groupedDataCurve).map(([countryName, countryData]) => ({
        label: countryName,
        options: countryData.map(item => ({
            label: item.type,
            value: item?._id,
        })),
    }));


    // for tenure group data
    useEffect(() => {

        const groupedData2 = {};
        if (ycrAssetData?.records?.length > 0) {
            groupedData2.all = [{ label: "All", value: "all" }]; // Add "all" option

            for (const record of ycrAssetData.records) {
                const countryName = record.country?.countryName || "Unknown"; // Check and set default for missing countryName

                groupedData2[countryName] = groupedData2[countryName] || []; // Initialize empty array if not already present
                groupedData2[countryName]?.push({ label: countryName, value: record._id }); // Push record data
            }
        }

        setGroupedDataTenure(groupedData2)
    }, [ycrAssetData?.records]);

    const transformedDataTenure = Object.entries(groupedDataTenure).map(([countryName, countryData]) => {
        return {
            label: countryName,
            options: countryData.map(item => ({
                label: item.label,
                value: item?.value,
            })),
        }
    });

    // show all and other labels of group 

    const formatGroupLabel = (group) => {
        return (
            <div className='text-[12px] pt-1 pb-2 font-bold tracking-widest'>
                {group?.label}
            </div>
        )
    };


    return (
        <>
            <Dialog open={props.show} onOpenChange={props.onHide}>
                <DialogContent className="sm:max-w-[80%] gap-0 p-0">
                    <DialogHeader className="p-5 border-b border-borderV1">
                        <DialogTitle className="text-start">{(formData?.id === undefined || formData?.id === null) ? 'Add Asset' : "Edit Asset"}</DialogTitle>
                    </DialogHeader>
                    <div className="dialog-body p-5">
                        <div className='grid grid-cols-1 items-center gap-1'>
                            <div className="form-group grid grid-cols-12 items-center gap-1">
                                <div className="lable-wrapper  col-span-12">
                                    <Label htmlFor="name" className="text-[13px] text-textV2 font-500 cursor-pointer">
                                        Name:<span style={{ color: 'red' }}>*</span>
                                    </Label>
                                </div>
                                <div className="field-wrapper col-span-12">
                                    <Input className={`w-full h-[34px] text-[13px] rounded-[12px] form-control py-2 shadow-none  ${errors['names'] && 'is-invalid'}`} autoComplete={'off'} name='name' placeholder='Name' onChange={(e) => onChangeHandel(e)} id="inputEmail3" type="text" value={formData.name} />

                                </div>
                            </div>
                            <div className={errors['names'] ? "text-red text-[10px]" : ''}>{errors['names'] ? errors['names'] : null}</div>
                            <div className="form-group grid grid-cols-12 items-center gap-1">
                                <div className="lable-wrapper  col-span-12">
                                    <Label htmlFor="name" className="text-[13px] text-textV2 font-500 cursor-pointer">
                                        Country:<span style={{ color: 'red' }}>*</span>
                                    </Label>
                                </div>
                                <div className="field-wrapper col-span-12">
                                    <Select

                                        onValueChange={(e) => onChangeCountry(JSON.parse(e))}
                                    >
                                        <SelectTrigger className="w-full h-[34px] text-[13px] rounded-[12px]">
                                            <SelectValue
                                                className='text-textV1'
                                                placeholder={formData.countriesId !== null ? formData?.countriesId?.label : "Select Country"}
                                            >
                                                {formData.countriesId !== null ? formData?.countriesId?.label : "Select Country"}
                                            </SelectValue>
                                        </SelectTrigger>
                                        <SelectContent>
                                            <SelectGroup>
                                                {
                                                    countryOptions && countryOptions.length > 0 ? countryOptions.map((item, index) => {
                                                        return <SelectItem key={index} className="text-xs flex items-center gap-2 cursor-pointer text-theme font-500 hover:bg-[#d7ebff] rounded-[4px] py-2" value={JSON.stringify(item)}>{item?.label}</SelectItem>
                                                    }) : <SelectItem disabled className="text-xs flex items-center gap-2 cursor-pointer text-theme font-500 hover:bg-[#d7ebff] rounded-[4px] py-2 text-center" value={'No option'}>{'No option'}</SelectItem>
                                                }
                                            </SelectGroup>
                                        </SelectContent>
                                    </Select>
                                </div>
                            </div>
                            <div className={errors['countriesId'] ? "text-red text-[10px]" : ''}>{errors['countriesId'] ? errors['countriesId'] : null}</div>

                            <div className="form-group grid grid-cols-12 items-center gap-1">
                                <div className="lable-wrapper  col-span-12">
                                    <Label htmlFor="name" className="text-[13px] text-textV2 font-500 cursor-pointer">
                                        Curve:<span style={{ color: 'red' }}>*</span>
                                    </Label>
                                </div>
                                <div className="field-wrapper col-span-12">
                                    <Select
                                        onValueChange={(e) => onChangeInterestRateDataType(JSON.parse(e))}
                                    >
                                        <SelectTrigger className="w-full h-[34px] text-[13px] rounded-[12px]">
                                            <SelectValue
                                                className='text-textV1'

                                                placeholder={formData.interestRateDataTypeId !== null ? formData?.interestRateDataTypeId?.label : "Select Curve"}
                                            >
                                                {formData.interestRateDataTypeId !== null ? formData?.interestRateDataTypeId?.label : "Select Curve"}
                                            </SelectValue>
                                        </SelectTrigger>
                                        <SelectContent>
                                            <SelectGroup>
                                                {
                                                    InterestRateDataTypeOptions && InterestRateDataTypeOptions.length > 0 ? InterestRateDataTypeOptions.map((item, index) => {
                                                        return <SelectItem key={index} className="text-xs flex items-center gap-2 cursor-pointer text-theme font-500 hover:bg-[#d7ebff] rounded-[4px] py-2" value={JSON.stringify(item)}>{item?.label}</SelectItem>
                                                    }) : <SelectItem disabled className="text-xs flex items-center gap-2 cursor-pointer text-theme font-500 hover:bg-[#d7ebff] rounded-[4px] py-2 text-center" value={'No option'}>{'No option'}</SelectItem>
                                                }
                                            </SelectGroup>
                                        </SelectContent>
                                    </Select>
                                </div>
                            </div>
                            <div className={errors['interestRateDataTypeId'] ? "text-red text-[10px]" : ''}>{errors['interestRateDataTypeId'] ? errors['interestRateDataTypeId'] : null}</div>

                            <div className="form-group grid grid-cols-12 items-center gap-1">
                                <div className="lable-wrapper col-span-4lable-wrapper col-span-12">
                                    <Label htmlFor="name" className="text-[13px] text-textV2 font-500 cursor-pointer">
                                        Tenor: <span style={{ color: 'red' }}>*</span>
                                    </Label>
                                </div>
                                <div className="field-wrapper col-span-12">
                                    <ReactSelect
                                        components={{ Option: OptionCustomField }}
                                        isSearchable={false}
                                        inputValue=""
                                        isDisabled={formData.interestRateDataTypeId === null}
                                        closeMenuOnSelect={false}
                                        value={null}
                                        className='w-full h-[34px] text-[13px] !rounded-[15px] !text-black multi_react_select'
                                        onCheckedCustomFieldBox={onCheckedCustomFieldBox}
                                        placeholder={assetLabel !== null ? assetLabel : 'Select Tenor Option'}
                                        name="Asset"
                                        options={assetOptions}
                                        styles={{
                                            menuList: (base) => ({
                                                ...base,
                                                fontSize: "10px",
                                                overflow: "auto",
                                                maxHeight: "180px",
                                                lineHeight: '1rem',
                                                fontWeight: 500,
                                                borderRadius: '0',
                                                backgroundColor: 'transparent'

                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                overflow: "auto",
                                                margin: 0,
                                                padding: 0,
                                                width: '100%',
                                                borderRadius: '0',

                                            }),

                                        }}
                                    />

                                </div>
                            </div>
                            <div className={errors['assetIds'] ? "text-red text-[10px]" : ''}>{errors['assetIds'] ? errors['assetIds'] : null}</div>

                            <div className="form-group grid grid-cols-12 items-center gap-1">
                                <div className="lable-wrapper  col-span-12">
                                    <Label htmlFor="name" className="text-[13px] text-textV2 font-500 cursor-pointer">
                                        Currency:<span style={{ color: 'red' }}>*</span>
                                    </Label>
                                </div>
                                <div className="field-wrapper col-span-12">
                                    <Select

                                        onValueChange={(e) => onChangeCurrency(JSON.parse(e))}
                                    >
                                        <SelectTrigger className="w-full h-[34px] text-[13px] rounded-[12px]">
                                            <SelectValue
                                                className='text-textV1'

                                                placeholder={formData?.currencyId?.label || "Select Currency"}
                                            >
                                                {formData?.currencyId?.label || "Select Currency"}
                                            </SelectValue>
                                        </SelectTrigger>
                                        <SelectContent>
                                            <SelectGroup>
                                                {
                                                    currencyOptions && currencyOptions.length > 0 ? currencyOptions.map((item, index) => {
                                                        return <SelectItem key={index} className="text-xs flex items-center gap-2 cursor-pointer text-theme font-500 hover:bg-[#d7ebff] rounded-[4px] py-2" value={JSON.stringify(item)}>{item?.label}</SelectItem>
                                                    }) : <SelectItem disabled className="text-xs flex items-center gap-2 cursor-pointer text-theme font-500 hover:bg-[#d7ebff] rounded-[4px] py-2 text-center" value={'No option'}>{'No option'}</SelectItem>
                                                }
                                            </SelectGroup>
                                        </SelectContent>
                                    </Select>
                                </div>
                            </div>
                            <div className={errors['currencyId'] ? "text-red text-[10px]" : ''}>{errors['currencyId'] ? errors['currencyId'] : null}</div>


                            <div className="form-group grid grid-cols-12 items-center gap-1">
                                <div className="lable-wrapper col-span-12">
                                    <Label htmlFor="username" className="text-[13px] text-textV2 font-500 cursor-pointer">
                                        Description:
                                    </Label>
                                </div>
                                <div className="field-wrapper col-span-12">
                                    <Textarea
                                        className={`form-control shadow-none fs-13 px-2 ${errors['description'] && 'is-invalid'}`} name='description' onChange={(e) => onChangeHandel(e)} id="basic-form-textarea" rows="3" placeholder="Description" value={formData.description} />
                                    
                                </div>
                            </div>


                        </div>

                    </div>
                    <DialogFooter className={"!justify-center !gap-2 p-5"}>
                        <Button type="submit" size="sm" className="min-w-[100px]" onClick={onSave}>Save</Button>
                        <Button type="submit" className="min-w-[100px]" size="sm" variant={"outline"} onClick={props.onHide}>Cancel</Button>
                    </DialogFooter>
                </DialogContent>
            </Dialog>
        </>
    )
}

export default AssetModel
